import React, { useContext, useEffect, useState } from "react";
import "./styles.sass";
import Report from "./Report";
import { Context } from "../..";
import Emptiness from "../../components/UI/emptiness/Emptiness";
import Spinner from "../../components/UI/spinner/Spinner";
import Timofey from "../../assets/images/Timofey_avatar.png";
import searchIcon from "../../assets/icons/search.svg";
import { showSuccessToast } from "../../components/toasts";

const PropertyReports = () => {
  const { site, store, roles } = useContext(Context);

  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [adminPermissionData, setAdminPermissionData] = useState<any>()

  async function loadUserReports(){
    try {
      setLoading(true)
      const response = await site.loadReports();
      setReports(response)
      setLoading(false)
    } catch (error) {
      console.error("Error while fetching data:", error)
    }
  }

  useEffect(() => {
    setLoading(true);
    loadUserReports().then((res) => {
      setLoading(false);
    })
  }, []);

  const searchItems = (searchValue: string) => {
    if (searchValue !== "") {
      const filteredData = site.reports.filter((item: any) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchValue.toLowerCase());
      });
      setReports(filteredData);
    } else {
      setReports(site.reports);
    }
  };

  const deletePropertyReport = async (id: any) => {
    try {
      if (window.confirm("Are you sure you want to delete this Property Report?")) {
        await site.deleteReport(id).then(() => {
          loadUserReports()
        })
      }
     } catch (error) {
      console.log(error)
     }
  }

  useEffect(() => {
    loadNewData()
  }, [])

  const loadNewData = async () => {
    const userData = store?.user?.role?.find((par: any) => par?.path === "control")?.children?.find((child: any) => child.path === "property-reports")
    setAdminPermissionData(userData)
  };

  return (
    <>
      <div className="title">Property Reports</div>
      <label className="search-bar" htmlFor="search">
        <span className="input-container">
          <span className="icon">
            <img src={searchIcon} alt="search" />
          </span>
          <input
            type="text"
            id="search"
            className="input"
            // value={searchValue}
            onChange={(e) => searchItems(e.target.value)}
            placeholder="Search for reports"
          />
        </span>
      </label>
      <div
        className="r-card-container mainBackgroundBox"
        style={{
          display: loading ? "flex" : "grid",
        }}
      >
        {reports.length > 0 && !loading ? (
          reports.map((report: any) => (
            <Report
              key={report._id}
              data={report}
              handleReport={site}
              setReports={setReports}
              deletePropertyReport={deletePropertyReport}
              actionData={adminPermissionData}
            />
          ))
        ) : reports.length === 0 && !loading ? (
          <Emptiness icon={Timofey} content="No Reports!" />
        ) : (
            <Spinner />
        )}
      </div>
    </>
  );
};

export default PropertyReports;
